const handler = ( $ ) => {
	const $allItems = $( '.accordion__item' );

	const itemClickHandler = function () {
		const $clickedItem = $( this ),
			$expItem = $clickedItem
				.siblings( '.accordion__item--expanded' )
				.not( $clickedItem ),
			$expTray = $expItem.next( '.accordion__tray' ),
			isExpClickedItem = $clickedItem.hasClass(
				'accordion__item--expanded'
			),
			hasOtherExpTray = $expTray.length != 0;

		const toggleItem = ( $item, whenAnim ) => {
			$item.next( '.accordion__tray' ).slideToggle( {
				[ whenAnim ]: () =>
					$item.toggleClass( 'accordion__item--expanded' ),
			} );
		};

		if ( hasOtherExpTray ) {
			toggleItem( $expItem, 'done' );
			toggleItem( $clickedItem, 'start' );
		} else if ( isExpClickedItem ) {
			toggleItem( $clickedItem, 'done' );
		} else {
			toggleItem( $clickedItem, 'start' );
		}
	};

	$allItems.on( 'click', itemClickHandler );

	// Custom paddings
	const $accordionBlock = $( '.accordion-block' ),
		$nextBlock = $accordionBlock.parents().next();

	if (
		$nextBlock.find( 'single-flair-top-wave-block' ) != 0 ||
		$nextBlock.find( 'single-flair-bottom-wave-block' ) != 0 ||
		$nextBlock.find( 'double-flair-top-wave-block' ) != 0 ||
		$nextBlock.find( 'double-flair-bottom-wave-block' ) != 0
	) {
		$accordionBlock.addClass( 'accordion-block--padding_20-80' );
	}
};

( ( $ ) => {
	$( handler );
} )( jQuery );
